import { getOptionalAndCannedQuestions } from '../../containers/checkout/utils';
import { CheckoutState } from '../../state';
import { getQuestionsForBuyer } from './buyer';

export const getCannedAndOptionalQuestionsForBuyer = (state: CheckoutState) =>
    getOptionalAndCannedQuestions(getQuestionsForBuyer(state));
